import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logout } from '../store/authSlice'
import { 
  hasPermission, 
  hasRole, 
  isAdmin, 
  hasRoutePermission,
  hasAnyPermission,
  hasAllPermissions,
  getUserPermissions
} from '../utils/permissions'
import apiService from '../services/api'

/**
 * 认证相关的自定义Hook
 */
export const useAuth = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const auth = useSelector(state => state.auth)
  const { user, token, isAuthenticated, loading, error } = auth

  /**
   * 退出登录
   */
  const handleLogout = async () => {
    try {
      // 调用后端退出登录接口
      await apiService.auth.logout()
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      // 无论后端调用是否成功，都清除前端状态
      dispatch(logout())
      navigate('/login')
    }
  }

  /**
   * 检查是否有指定权限
   */
  const checkPermission = (permission) => {
    return hasPermission(user, permission)
  }

  /**
   * 检查是否有指定角色
   */
  const checkRole = (role) => {
    return hasRole(user, role)
  }

  /**
   * 检查是否是管理员
   */
  const checkIsAdmin = () => {
    return isAdmin(user)
  }

  /**
   * 检查路由访问权限
   */
  const checkRoutePermission = (route) => {
    return hasRoutePermission(user, route)
  }

  /**
   * 检查是否有任意权限
   */
  const checkAnyPermission = (permissions) => {
    return hasAnyPermission(user, permissions)
  }

  /**
   * 检查是否有所有权限
   */
  const checkAllPermissions = (permissions) => {
    return hasAllPermissions(user, permissions)
  }

  /**
   * 获取用户所有权限
   */
  const userPermissions = getUserPermissions(user)

  return {
    // 认证状态
    user,
    token,
    isAuthenticated,
    loading,
    error,
    
    // 方法
    logout: handleLogout,
    
    // 权限检查
    hasPermission: checkPermission,
    hasRole: checkRole,
    isAdmin: checkIsAdmin,
    hasRoutePermission: checkRoutePermission,
    hasAnyPermission: checkAnyPermission,
    hasAllPermissions: checkAllPermissions,
    
    // 权限列表
    permissions: userPermissions
  }
} 